import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeProvider";

import Landing from "@/pages/Landing";
import CreateSession from "@/pages/CreateSession";
import UploadReceipt from "@/pages/UploadReceipt";
import ReviewItems from "@/pages/ReviewItems";
import ShareSession from "@/pages/ShareSession";
import HostDashboard from "@/pages/HostDashboard";
import JoinSession from "@/pages/JoinSession";
import SelectItems from "@/pages/SelectItems";
import Summary from "@/pages/Summary";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/create" element={<CreateSession />} />
            <Route path="/session/:code/upload" element={<UploadReceipt />} />
            <Route path="/session/:code/review" element={<ReviewItems />} />
            <Route path="/session/:code/share" element={<ShareSession />} />
            <Route path="/session/:code/dashboard" element={<HostDashboard />} />
            <Route path="/session/:code/summary" element={<Summary />} />
            <Route path="/join/:code" element={<JoinSession />} />
            <Route path="/session/:code/select" element={<SelectItems />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
